<script setup lang="ts">
  defineProps<{
    locked?: boolean
  }>()
</script>

<template>
  <div
    class="hover absolute inset-0 md:hover:opacity-100 md:bg-black-10/35 leading-none transition-opacity p-2 cursor-pointer"
    :class="locked ? 'opacity-100' : 'md:opacity-0'"
  >
    <slot></slot>
  </div>
</template>

<style scoped>
  [data-modal] .hover {
    transition: none;
  }
</style>
